export default __webpack_public_path__ + "static/media/ThumbsDown_Small_FilledBlack.bbbb9e20.svg";